<div class="sidebar" [ngClass]='{"open":state}'>
    <div class="sidebarInner">
      <nav>
        <dl *ngFor="let link of sbLinks$ | async">
          <dt class="menu01" [routerLink]="link.firstLink[0]" (click)="toggleMenu(link.firstLink[1])">{{link.firstLink[1] | uppercase}}</dt>
          <div class="hideOverflow">
            <dd [ngClass]="{'open': activeLink == link.firstLink[1]}" >
              <dl (click)="toggleSubMenu(subLink.data, subLink.scroll)" routerLinkActive="active" *ngFor="let subLink of link.secondLink" >
                <a [routerLink]="[subLink.url]" class="menu01 secondMenu" >{{subLink.data}}</a>
                <div class="hideOverflow">
                    <dd [ngClass]="{'open': subActiveLink == subLink.data }" >
                      <dl *ngFor="let inner of subLink.innerLink" (click)="sidebarNavConnect()" >
                        <a (click)="clickSubSubMenu($event, inner)" [routerLink]="[subLink.url]" class="thirdMenu" >{{inner}}</a>
                      </dl>
                    </dd>
                </div>
                </dl>
            </dd>
          </div>
        </dl>
        <div class="divformargin"></div>
      </nav>
      <div class="legal"></div>
    </div>

    <!-- <div class="copyright">
      <p>Copyrights &copy; 2017
        <a href="http://vml.kaist.ac.kr/" title="">Visual Media Lab, KAIST</a>. All Right Reserved.</p>
    </div> -->

  </div>

  <div (click)="sidebarNavConnect()" class="make_dimmer" [ngClass]='{"dimmer":state}'></div>




// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-sidebar/main-sidebar.component.html